import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import DataTable from "react-data-table-component";
import { useGlobalContext } from '../GlobalContext';

const ListAnggota = () => {
  const { api, isReady } = useGlobalContext();

  const [showModal, setShowModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [anggota, setAnggota] = useState([]);
  const [unitkerja, setUnitKerja] = useState([]);
  const [searchText, setSearchText] = useState("");

  const [formData, setFormData] = useState({
    noanggota: '',
    nama: '',
    alamat: '',
    kota: '',
    telp: '',
    gender: "1",
    tempat: '',
    tgllahir: '',
    tglmasuk: '',
    pekerjaan: '',
    agama: "1",
    aktif: true,
    pendidikan: '-',
    tutup: false,
    tgltutup: '',
    kodeuk: '',
    anggota_usp: false,
    anggota_mnsuka: false,
    anggota_hrraya: false,
    jenis_mnsuka: 1,
    unitkerja: ''
  });

  const [editData, setEditData] = useState({
    noanggota: '',
    nama: '',
    alamat: '',
    kota: '',
    telp: '',
    jenkel: 1,
    tempat: '',
    tgllahir: '',
    tglmasuk: '',
    pekerjaan: '',
    agama: "1",
    aktif: true,
    pendidikan: '-',
    tutup: false,
    tgltutup: '',
    kodeuk: '',
    anggota_usp: false,
    anggota_mnsuka: false,
    anggota_hrraya: false,
    jenis_mnsuka: 1
  });

  useEffect(() => {
    if (isReady) {
      getAnggota();
      getUnitKerja();
    }
  }, [isReady]);

  const getAnggota = async () => {
    try {
      const response = await api.get('/api/anggota');
      const newData = response.data.data || [];
      const transformedData = newData.map(item => ({
        ...item,
        anggota_usp: item.anggota_usp === "1",
        anggota_mnsuka: item.anggota_mnsuka === "1",
        anggota_hrraya: item.anggota_hrraya === "1",
        jenis_mnsuka: Number(item.jenis_mnsuka)
      }));
      setAnggota(transformedData);
    } catch (error) {
      console.error('❌ Error get anggota:', error.response?.data || error.message);
    }
  };

  const getUnitKerja = async () => {
    try {
      const response = await api.get('/api/unit');
      setUnitKerja(response.data.data || []);
    } catch (error) {
      console.error('❌ Error get unitkerja:', error.response?.data || error.message);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const dataToSend = {
        ...formData,
        anggota_usp: formData.anggota_usp ? 1 : 0,
        anggota_mnsuka: formData.anggota_mnsuka ? 1 : 0,
        anggota_hrraya: formData.anggota_hrraya ? 1 : 0,
      };
      await api.post('/api/anggota', dataToSend);
      setShowModal(false);
      getAnggota();
      setFormData({
        noanggota: '',
        nama: '',
        alamat: '',
        kota: '',
        telp: '',
        gender: "1",
        tempat: '',
        tgllahir: '',
        tglmasuk: '',
        pekerjaan: '',
        agama: "1",
        aktif: true,
        pendidikan: '-',
        tutup: false,
        tgltutup: '',
        kodeuk: '',
        anggota_usp: false,
        anggota_mnsuka: false,
        anggota_hrraya: false,
        jenis_mnsuka: 1,
        unitkerja: ''
      });
    } catch (error) {
      console.error('❌ Error submit:', error.response?.data || error.message);
      alert('Gagal menyimpan data.');
    }
  };

  const deleteAnggota = async (noanggota) => {
    if (window.confirm("Yakin ingin menghapus data ini?")) {
      try {
        await api.delete(`/api/anggota/${noanggota}`);
        alert("Data berhasil dihapus.");
        getAnggota();
      } catch (error) {
        console.error('❌ Error delete:', error.response?.data || error.message);
        alert('Gagal menghapus data.');
      }
    }
  };

  const handleEditSubmit = async () => {
    try {
      const dataToSend = {
        ...editData,
        anggota_usp: editData.anggota_usp ? 1 : 0,
        anggota_mnsuka: editData.anggota_mnsuka ? 1 : 0,
        anggota_hrraya: editData.anggota_hrraya ? 1 : 0,
        jenkel: Number(editData.jenkel),
        agama: Number(editData.agama),
        jenis_mnsuka: Number(editData.jenis_mnsuka)
      };
      await api.patch(`/api/anggota/${editData.noanggota}`, dataToSend);
      setShowEditModal(false);
      getAnggota();
    } catch (error) {
      console.error('❌ Error update:', error.response?.data || error.message);
      alert('Gagal menyimpan perubahan.');
    }
  };

  const handleChangeForm = (e) => {
    const { name, type, value, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === "checkbox" ? checked : type === "radio" ? Number(value) : value
    }));
  };

  const handleChangeFormEdit = (e) => {
    const { name, type, value, checked } = e.target;
    setEditData(prev => ({
      ...prev,
      [name]: type === "checkbox" ? checked : type === "radio" ? Number(value) : value
    }));
  };

  const handleEditClick = (noanggota) => {
    const found = anggota.find(a => a.noanggota === noanggota);
    if (found) {
      setEditData({
        ...found,
        // Make sure jenkel is the key used for gender in editData
        jenkel: found.gender,
        anggota_usp: found.anggota_usp === true,
        anggota_mnsuka: found.anggota_mnsuka === true,
        anggota_hrraya: found.anggota_hrraya === true,
        jenis_mnsuka: Number(found.jenis_mnsuka),
        jenkel: Number(found.jenkel),
        tgllahir: found.tgllahir ? new Date(found.tgllahir).toISOString().split('T')[0] : '',
        tglmasuk: found.tglmasuk ? new Date(found.tglmasuk).toISOString().split('T')[0] : '',
      });
      setShowEditModal(true);
    }
  };

  const columns = [
    {
      name: "Nomor",
      selector: (row, index) => index + 1,
      width: "60px",
      center: true,
    },
    {
      name: "No. Anggota",
      selector: (row) => row.noanggota,
      sortable: true,
      center: true,
      cell: (row) => (
        <Link to={`/editanggota/${row.noanggota}`} className='button is-small is-info'>
          {row.noanggota}
        </Link>
      ),
    },
    {
      name: "Nama",
      selector: (row) => row.nama,
      sortable: true,
    },
    {
      name: "Unit Kerja",
      selector: (row) => row.unitkerja,
      sortable: true,
    },
    {
      name: "Aksi",
      cell: (row) => (
        <div className="d-flex gap-2 justify-content-center">
          <button className="btn btn-info btn-sm" onClick={() => handleEditClick(row.noanggota)}>
            <i className="fa fa-edit" /> Edit
          </button>
          <button className="btn btn-danger btn-sm" onClick={() => deleteAnggota(row.noanggota)}>
            <i className="fa fa-trash" /> Delete
          </button>
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      width: "180px",
      center: true,
    },
  ];

  const filteredData = anggota.filter(
    (item) =>
      item.noanggota.toLowerCase().includes(searchText.toLowerCase()) ||
      item.nama.toLowerCase().includes(searchText.toLowerCase()) ||
      (item.unitkerja && item.unitkerja.toLowerCase().includes(searchText.toLowerCase()))
  );

  // The customStyles object is defined but not used in the DataTable. I'll remove it to avoid confusion, and fix the inline style that's already there.

  return (
    <div className="card shadow-sm">
      <div className="card-header">
          <div className="d-flex justify-content-end align-items-center w-100">
            <h4 className="mb-0" style={{ fontSize: "22px" }}>DAFTAR ANGGOTA</h4>
           <button
            className="btn btn-primary btn-sm"
            style={{ fontSize: "14px", padding: "6px 14px" }}
            onClick={() => {
              setFormData({
                noanggota: '',
                nama: '',
                alamat: '',
                kota: '',
                telp: '',
                gender: "1",
                tempat: '',
                tgllahir: '',
                tglmasuk: '',
                pekerjaan: '',
                agama: "1",
                aktif: true,
                pendidikan: '-',
                tutup: false,
                tgltutup: '',
                kodeuk: '',
                anggota_usp: false,
                anggota_mnsuka: false,
                anggota_hrraya: false,
                jenis_mnsuka: 1,
                unitkerja: ''
              });
              setShowModal(true);
            }}
          >
            Tambah Data
          </button>
        </div>
      </div>

      <div className="card-body">
        <div className="mb-2 d-flex justify-content-end">
          <input
            type="text"
            className="form-control form-control-sm"
            style={{ maxWidth: "200px" }}
            placeholder="Cari No. Anggota/Nama/Unit Kerja..."
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
          />
        </div>
        <DataTable
          columns={columns}
          data={filteredData}
          pagination
          striped
          dense
          highlightOnHover
          responsive
          customStyles={{
            headCells: {
              style: {
                fontWeight: 'bold',
                fontSize: '16px',
                backgroundColor: '#f0f0f0',
                padding: '10px 12px',
                borderRight: '2px solid #ddd',
              },
            },
            cells: {
              style: {
                borderRight: '1px solid #ddd',
                padding: '12px 10px',
              },
            },
            rows: {
              style: {
                borderBottom: '1px solid #eee',
              },
            },
          }}
        />
      </div>

      {/* Modal Tambah */}
      {showModal && (
        <div className="modal show d-block" tabIndex="-1" role="dialog">
          <div className="modal-dialog modal-lg" role="document">
            <div className="card card-info" style={{ width: "100%" }}>
              <div className="modal-content">
                <div className="card-header">
                  <h2 className="card-title" style={{ display: "flex" }}>
                    Entri Data Anggota
                  </h2>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setShowModal(false)}
                  >
                  </button>
                </div>
                <div className="modal-body" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                  <form className="form-horizontal" onSubmit={handleSubmit}>
                    {/* Form fields... */}
                    <div className="form-group row mb-3">
                      <label htmlFor="noanggota" className="col-sm-3 col-form-label">No. Anggota</label>
                      <div className="col-sm-4">
                        <input
                          type="number"
                          className="form-control"
                          id="noanggota"
                          name="noanggota"
                          value={formData.noanggota}
                          onChange={handleChangeForm}
                          required
                        />
                      </div>
                    </div>
                    <div className="form-group row mb-3">
                      <label htmlFor="nama" className="col-sm-3 col-form-label">Nama</label>
                      <div className="col-sm-9">
                        <input
                          type="text"
                          className="form-control"
                          id="nama"
                          name="nama"
                          value={formData.nama}
                          onChange={handleChangeForm}
                          required
                        />
                      </div>
                    </div>
                    <div className="form-group row mb-3">
                      <label htmlFor="alamat" className="col-sm-3 col-form-label">Alamat</label>
                      <div className="col-sm-9">
                        <input
                          type="text"
                          className="form-control"
                          id="alamat"
                          name="alamat"
                          value={formData.alamat}
                          onChange={handleChangeForm}
                        />
                      </div>
                    </div>
                    <div className="form-group row mb-3">
                      <label htmlFor="kota" className="col-sm-3 col-form-label">Kota</label>
                      <div className="col-sm-9">
                        <input
                          type="text"
                          className="form-control"
                          id="kota"
                          name="kota"
                          value={formData.kota}
                          onChange={handleChangeForm}
                        />
                      </div>
                    </div>
                    <div className="form-group row mb-3">
                      <label htmlFor="telp" className="col-sm-3 col-form-label">Telp / HP</label>
                      <div className="col-sm-9">
                        <input
                          type="text"
                          className="form-control"
                          id="telp"
                          name="telp"
                          value={formData.telp}
                          onChange={handleChangeForm}
                        />
                      </div>
                    </div>
                    <div className="form-group row mb-3">
                      <label htmlFor="gender" className="col-sm-3 col-form-label">Gender</label>
                      <div className="col-sm-9">
                        <select
                          className="form-control"
                          id="gender"
                          name="gender"
                          value={formData.gender}
                          onChange={handleChangeForm}
                        >
                          <option value="1">LAKI-LAKI</option>
                          <option value="2">PEREMPUAN</option>
                        </select>
                      </div>
                    </div>
                    <div className="form-group row mb-3">
                      <label htmlFor="tempat" className="col-sm-3 col-form-label">Tempat Lahir</label>
                      <div className="col-sm-9">
                        <input
                          type="text"
                          className="form-control"
                          id="tempat"
                          name="tempat"
                          value={formData.tempat}
                          onChange={handleChangeForm}
                        />
                      </div>
                    </div>
                    <div className="form-group row mb-3">
                      <label htmlFor="tgllahir" className="col-sm-3 col-form-label">Tanggal Lahir</label>
                      <div className="col-sm-9">
                        <input
                          type="date"
                          className="form-control"
                          id="tgllahir"
                          name="tgllahir"
                          value={formData.tgllahir}
                          onChange={handleChangeForm}
                        />
                      </div>
                    </div>
                    <div className="form-group row mb-3">
                      <label htmlFor="tglmasuk" className="col-sm-3 col-form-label">Tgl. Masuk</label>
                      <div className="col-sm-9">
                        <input
                          type="date"
                          className="form-control"
                          id="tglmasuk"
                          name="tglmasuk"
                          value={formData.tglmasuk}
                          onChange={handleChangeForm}
                        />
                      </div>
                    </div>
                    <div className="form-group row mb-3">
                      <label htmlFor="pekerjaan" className="col-sm-3 col-form-label">Pekerjaan</label>
                      <div className="col-sm-9">
                        <input
                          type="text"
                          className="form-control"
                          id="pekerjaan"
                          name="pekerjaan"
                          value={formData.pekerjaan}
                          onChange={handleChangeForm}
                        />
                      </div>
                    </div>
                    <div className="form-group row mb-3">
                      <label htmlFor="agama" className="col-sm-3 col-form-label">Agama</label>
                      <div className="col-sm-9">
                        <select
                          className="form-control"
                          id="agama"
                          name="agama"
                          value={formData.agama}
                          onChange={handleChangeForm}
                        >
                          <option value="1">ISLAM</option>
                          <option value="2">KRISTEN</option>
                          <option value="3">KATOLIK</option>
                          <option value="4">HINDU</option>
                          <option value="5">BUDHA</option>
                          <option value="6">KONGHUCU</option>
                        </select>
                      </div>
                    </div>
                    <div className="form-group row mb-3">
                      <label htmlFor="pendidikan" className="col-sm-3 col-form-label">Pendidikan</label>
                      <div className="col-sm-9">
                        <input
                          type="text"
                          className="form-control"
                          id="pendidikan"
                          name="pendidikan"
                          value={formData.pendidikan}
                          onChange={handleChangeForm}
                        />
                      </div>
                    </div>
                    <div className="form-group row mb-3">
                      <label htmlFor="kodeuk" className="col-sm-3 col-form-label">Unit Kerja</label>
                      <div className="col-sm-9">
                        <select
                          className="form-control"
                          id="kodeuk"
                          name="kodeuk"
                          value={formData.kodeuk}
                          onChange={handleChangeForm}
                        >
                          <option value="">--pilih--</option>
                          {unitkerja.map((option) => (
                            <option key={option.kode} value={option.kode}>
                              {option.unitkerja}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="form-group row mb-3">
                      <label className="col-sm-3 col-form-label">Keanggotaan</label>
                      <div className="col-sm-9 d-flex align-items-center">
                        <fieldset style={{ border: "1px solid #D0DDD0", padding: "10px", width: "100%" }}>
                          <div className="d-flex flex-wrap gap-3">
                            <div className="form-check">
                              <input type="checkbox" id="anggota_usp" name="anggota_usp" className="form-check-input" checked={formData.anggota_usp} onChange={handleChangeForm} />
                              <label htmlFor="anggota_usp" className="form-check-label ms-2">USP</label>
                            </div>
                            <div className="form-check">
                              <input type="checkbox" id="anggota_mnsuka" name="anggota_mnsuka" className="form-check-input" checked={formData.anggota_mnsuka} onChange={handleChangeForm} />
                              <label htmlFor="anggota_mnsuka" className="form-check-label ms-2">MANASUKA</label>
                            </div>
                            <div className="form-check">
                              <input type="checkbox" id="anggota_hrraya" name="anggota_hrraya" className="form-check-input" checked={formData.anggota_hrraya} onChange={handleChangeForm} />
                              <label htmlFor="anggota_hrraya" className="form-check-label ms-2">HARIRAYA</label>
                            </div>
                          </div>
                        </fieldset>
                      </div>
                    </div>
                    <div className="form-group row mb-3">
                      <label className="col-sm-3 col-form-label">Jenis Manasuka</label>
                      <div className="col-sm-9 d-flex align-items-center">
                        <fieldset style={{ border: "1px solid #D0DDD0", padding: "10px", width: "100%" }}>
                          <div className="d-flex flex-wrap gap-3">
                            <div className="form-check form-check-inline">
                              <input type="radio" name="jenis_mnsuka" id="jenis_anggota" value="1" checked={formData.jenis_mnsuka === 1} onChange={handleChangeForm} className="form-check-input" />
                              <label htmlFor="jenis_anggota" className="form-check-label ms-2">Anggota</label>
                            </div>
                            <div className="form-check form-check-inline">
                              <input type="radio" name="jenis_mnsuka" id="jenis_masyarakat" value="2" checked={formData.jenis_mnsuka === 2} onChange={handleChangeForm} className="form-check-input" />
                              <label htmlFor="jenis_masyarakat" className="form-check-label ms-2">Masyarakat</label>
                            </div>
                          </div>
                        </fieldset>
                      </div>
                    </div>
                    {/* Modal Tambah Footer */}
                    <div className="modal-footer">
                      <button type="button" className="btn btn-secondary" onClick={() => setShowModal(false)}>
                        Close
                      </button>
                      <button type="submit" className="btn btn-primary">
                        Save Changes
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal Edit (apply similar styling if needed for edit modal) */}
      {showEditModal && (
        <div className="modal show d-block" tabIndex="-1" role="dialog">
          <div className="modal-dialog modal-lg" role="document">
            <div className="card card-info" style={{ width: "100%" }}>
              <div className="modal-content">
                <div className="card-header">
                  <h3 className="card-title" ><b>Edit Data Anggota</b></h3>
                  <button type="button" className="btn-close" onClick={() => setShowEditModal(false)}>
                  </button>
                </div>
                <div className="modal-body" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                  <form className="form-horizontal" onSubmit={(e) => { e.preventDefault(); handleEditSubmit(); }}>
                    <div className="form-group row mb-3">
                      <label htmlFor="noanggota" className="col-sm-3 col-form-label">No. Anggota</label>
                      <div className="col-sm-4">
                        <input type="text" className="form-control" id="noanggota" name="noanggota" value={editData.noanggota} disabled />
                      </div>
                    </div>
                    <div className="form-group row mb-3">
                      <label htmlFor="nama" className="col-sm-3 col-form-label">Nama</label>
                      <div className="col-sm-9">
                        <input type="text" className="form-control" id="nama" name="nama" value={editData.nama} onChange={handleChangeFormEdit} required />
                      </div>
                    </div>
                    <div className="form-group row mb-3">
                      <label htmlFor="alamat" className="col-sm-3 col-form-label">Alamat</label>
                      <div className="col-sm-9">
                        <input type="text" className="form-control" id="alamat" name="alamat" value={editData.alamat} onChange={handleChangeFormEdit} />
                      </div>
                    </div>
                    <div className="form-group row mb-3">
                      <label htmlFor="kota" className="col-sm-3 col-form-label">Kota</label>
                      <div className="col-sm-9">
                        <input type="text" className="form-control" id="kota" name="kota" value={editData.kota} onChange={handleChangeFormEdit} />
                      </div>
                    </div>
                    <div className="form-group row mb-3">
                      <label htmlFor="telp" className="col-sm-3 col-form-label">Telp / HP</label>
                      <div className="col-sm-9">
                        <input type="text" className="form-control" id="telp" name="telp" value={editData.telp} onChange={handleChangeFormEdit} />
                      </div>
                    </div>
                    <div className="form-group row mb-3">
                      <label htmlFor="jenkel" className="col-sm-3 col-form-label">Gender</label>
                      <div className="col-sm-9">
                        <select className="form-control" id="jenkel" name="jenkel" value={editData.jenkel} onChange={handleChangeFormEdit}>
                          <option value="1">LAKI-LAKI</option>
                          <option value="2">PEREMPUAN</option>
                        </select>
                      </div>
                    </div>
                    <div className="form-group row mb-3">
                      <label htmlFor="tempat" className="col-sm-3 col-form-label">Tempat Lahir</label>
                      <div className="col-sm-9">
                        <input type="text" className="form-control" id="tempat" name="tempat" value={editData.tempat} onChange={handleChangeFormEdit} />
                      </div>
                    </div>
                    <div className="form-group row mb-3">
                      <label htmlFor="tgllahir" className="col-sm-3 col-form-label">Tanggal Lahir</label>
                      <div className="col-sm-9">
                        <input type="date" className="form-control" id="tgllahir" name="tgllahir" value={editData.tgllahir} onChange={handleChangeFormEdit} />
                      </div>
                    </div>
                    <div className="form-group row mb-3">
                      <label htmlFor="tglmasuk" className="col-sm-3 col-form-label">Tgl. Masuk</label>
                      <div className="col-sm-9">
                        <input type="date" className="form-control" id="tglmasuk" name="tglmasuk" value={editData.tglmasuk} onChange={handleChangeFormEdit} />
                      </div>
                    </div>
                    <div className="form-group row mb-3">
                      <label htmlFor="pekerjaan" className="col-sm-3 col-form-label">Pekerjaan</label>
                      <div className="col-sm-9">
                        <input type="text" className="form-control" id="pekerjaan" name="pekerjaan" value={editData.pekerjaan} onChange={handleChangeFormEdit} />
                      </div>
                    </div>
                    <div className="form-group row mb-3">
                      <label htmlFor="agama" className="col-sm-3 col-form-label">Agama</label>
                      <div className="col-sm-9">
                        <select className="form-control" id="agama" name="agama" value={editData.agama} onChange={handleChangeFormEdit}>
                          <option value="1">ISLAM</option>
                          <option value="2">KRISTEN</option>
                          <option value="3">KATOLIK</option>
                          <option value="4">HINDU</option>
                          <option value="5">BUDHA</option>
                          <option value="6">KONGHUCU</option>
                        </select>
                      </div>
                    </div>
                    <div className="form-group row mb-3">
                      <label htmlFor="pendidikan" className="col-sm-3 col-form-label">Pendidikan</label>
                      <div className="col-sm-9">
                        <input type="text" className="form-control" id="pendidikan" name="pendidikan" value={editData.pendidikan} onChange={handleChangeFormEdit} />
                      </div>
                    </div>
                    <div className="form-group row mb-3">
                      <label htmlFor="kodeuk" className="col-sm-3 col-form-label">Unit Kerja</label>
                      <div className="col-sm-9">
                        <select className="form-control" id="kodeuk" name="kodeuk" value={editData.kodeuk} onChange={handleChangeFormEdit}>
                          <option value="">--pilih--</option>
                          {unitkerja.map((option) => (
                            <option key={option.kode} value={option.kode}>
                              {option.unitkerja}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="form-group row mb-3">
                      <label className="col-sm-3 col-form-label">Keanggotaan</label>
                      <div className="col-sm-9 d-flex align-items-center">
                        <fieldset style={{ border: "1px solid #D0DDD0", padding: "10px", width: "100%" }}>
                          <div className="d-flex flex-wrap gap-3">
                            <div className="form-check">
                              <input
                                type="checkbox"
                                id="anggota_usp_edit"
                                name="anggota_usp"
                                className="form-check-input"
                                checked={editData.anggota_usp}
                                onChange={handleChangeFormEdit}
                              />
                              <label htmlFor="anggota_usp_edit" className="form-check-label ms-2">
                                USP
                              </label>
                            </div>
                            <div className="form-check">
                              <input
                                type="checkbox"
                                id="anggota_mnsuka_edit"
                                name="anggota_mnsuka"
                                className="form-check-input"
                                checked={editData.anggota_mnsuka}
                                onChange={handleChangeFormEdit}
                              />
                              <label htmlFor="anggota_mnsuka_edit" className="form-check-label ms-2">
                                MANASUKA
                              </label>
                            </div>
                            <div className="form-check">
                              <input
                                type="checkbox"
                                id="anggota_hrraya_edit"
                                name="anggota_hrraya"
                                className="form-check-input"
                                checked={editData.anggota_hrraya}
                                onChange={handleChangeFormEdit}
                              />
                              <label htmlFor="anggota_hrraya_edit" className="form-check-label ms-2">
                                HARIRAYA
                              </label>
                            </div>
                          </div>
                        </fieldset>
                      </div>
                    </div>
                    <div className="form-group row mb-3">
                      <label className="col-sm-3 col-form-label">Jenis Manasuka</label>
                      <div className="col-sm-9 d-flex align-items-center">
                        <fieldset style={{ border: "1px solid #D0DDD0", padding: "10px", width: "100%" }}>
                          <div className="d-flex flex-wrap gap-3">
                            <div className="form-check form-check-inline">
                              <input
                                type="radio"
                                name="jenis_mnsuka"
                                id="jenis_anggota_edit"
                                value="1"
                                checked={editData.jenis_mnsuka === 1}
                                onChange={handleChangeFormEdit}
                                className="form-check-input"
                              />
                              <label htmlFor="jenis_anggota_edit" className="form-check-label ms-2">
                                Anggota
                              </label>
                            </div>
                            <div className="form-check form-check-inline">
                              <input
                                type="radio"
                                name="jenis_mnsuka"
                                id="jenis_masyarakat_edit"
                                value="2"
                                checked={editData.jenis_mnsuka === 2}
                                onChange={handleChangeFormEdit}
                                className="form-check-input"
                              />
                              <label htmlFor="jenis_masyarakat_edit" className="form-check-label ms-2">
                                Masyarakat
                              </label>
                            </div>
                          </div>
                        </fieldset>
                      </div>
                    </div>
                    <div className="modal-footer">
                      <button type="button" className="btn btn-secondary" onClick={() => setShowEditModal(false)}>
                        Close
                      </button>
                      <button type="submit" className="btn btn-primary">
                        Save Changes
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ListAnggota;